/* eslint-disable */
import React, { useLayoutEffect } from "react";
import { AccidentBrochure, GlobeLifeLogo } from "../../../../../assets";
import VEBAccidentImage from "../../../../../assets/VEBPlanImages/VEBAccidentImage.avif";

import "./accidentIndemnity.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const AccidentInsurancePolicy: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="accident-indemnity-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Accident Insurance Policy</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={GlobeLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							A sudden accident resulting in an injury to you or a loved one can happen at any time. Being
							prepared for such an unexpected event and the financial challenges it may bring is
							essential.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A Globe Life Accident Insurance policy gives you an extra layer of financial
							security during these tough times—providing benefits that you can use to help keep the bills
							paid and protect your savings. That way, your focus can be on getting better.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBAccidentImage} alt="VEBAccidentImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={AccidentBrochure} />
			</div>
		</div>
	);
};

export default AccidentInsurancePolicy;
